import React from 'react';
import styled from 'styled-components';

const Section = styled.section`
  padding: clamp(70px, 11vw, 130px) 0;
  background: linear-gradient(180deg, #f7f3ee 0%, #ffffff 100%);
`;

const Inner = styled.div`
  display: grid;
  gap: clamp(32px, 6vw, 48px);
`;

const Header = styled.div`
  display: grid;
  gap: 12px;
  max-width: 640px;
`;

const Title = styled.h2`
  font-size: clamp(1.95rem, 3vw, 2.6rem);
  font-weight: 600;
  color: #2c2a29;
  letter-spacing: -0.01em;
`;

const Subtitle = styled.p`
  font-size: 1.05rem;
  line-height: 1.7;
  color: rgba(44, 42, 41, 0.7);
`;

const Testimonials = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: clamp(20px, 5vw, 32px);
`;

const TestimonialCard = styled.div`
  padding: 28px;
  border-radius: 26px;
  background: rgba(255, 255, 255, 0.75);
  border: 1px solid rgba(47, 58, 52, 0.08);
  box-shadow: 0 18px 32px rgba(37, 45, 40, 0.12);
  display: grid;
  gap: 16px;
  position: relative;
`;

const Quotation = styled.p`
  font-size: 1rem;
  line-height: 1.65;
  color: rgba(44, 42, 41, 0.78);
`;

const Author = styled.div`
  display: grid;
  gap: 4px;
`;

const Name = styled.span`
  font-size: 0.95rem;
  font-weight: 600;
  color: #2f3a34;
`;

const Meta = styled.span`
  font-size: 0.85rem;
  color: rgba(47, 58, 52, 0.55);
`;

const Stars = styled.div`
  display: inline-flex;
  gap: 4px;
  color: #d49a73;
`;

const testimonials = [
  {
    quote:
      'Alltid lika generös service och så fint paketerat! Buketten jag beställde levererades samma eftermiddag och doftljuset blev pricken över i:et.',
    name: 'Emma L.',
    meta: 'Kund i Kramfors'
  },
  {
    quote:
      'Lilla Flora hjälper oss att skapa stämning hemma inför varje helg. Fantastisk känsla för färg och form och alltid med personliga rekommendationer.',
    name: 'Jonas & Matilda',
    meta: 'Inredningskunder'
  },
  {
    quote:
      'Beställde en kondoleansbukett och blev så rörd av omtanken. Leveransen var punktlig och arrangemanget precis som vi önskade.',
    name: 'Karin S.',
    meta: 'Begravningsuppdrag'
  }
];

const SocialProofSection: React.FC = () => {
  return (
    <Section>
      <div className="container">
        <Inner>
          <Header>
            <Title>Vad våra kunder säger</Title>
            <Subtitle>
              Vi är stolta över att vara en del av många viktiga ögonblick – från vardagsmys till stora händelser.
              Tack för förtroendet och de varma orden.
            </Subtitle>
          </Header>
          <Testimonials>
            {testimonials.map(item => (
              <TestimonialCard key={item.name}>
                <Stars>★★★★★</Stars>
                <Quotation>“{item.quote}”</Quotation>
                <Author>
                  <Name>{item.name}</Name>
                  <Meta>{item.meta}</Meta>
                </Author>
              </TestimonialCard>
            ))}
          </Testimonials>
        </Inner>
      </div>
    </Section>
  );
};

export default SocialProofSection;
